/* eslint-disable camelcase */
// Camel case disabled since we are accessing raw values from API response.
import React from 'react';
import { useAuthStore } from '../store/auth-store';
import { ProfileBadge } from './profile-badge';

interface Props {}

export const UserProfileBadge: React.FC<Props> = () => {
  const {
    idToken: {
      payload: {
        given_name,
        family_name,
      },
    },
  } = useAuthStore();

  return <ProfileBadge firstName={given_name} lastName={family_name} />;
};
